import { useBookingContext } from "modules/Booking/BookingContext"
import { useFormPageContext } from "modules/Booking/FormPage/common/FormPageContext"
import { UserFormError } from "modules/Booking/FormPage/common/constants"

export function useUserFormErrors() {
    const [
        {
            form: {
                nameError,
                emailError,
                phoneError,
                showEmailError,
                eulaAccepted,
                offerAccepted,
                personalDataAccepted,
                informedAgreement,
            },
        },
    ] = useFormPageContext()

    const [{ isUserVerified }] = useBookingContext()

    const userFormErrors = [] as UserFormError[]
    !isUserVerified && (showEmailError || emailError) && userFormErrors.push(UserFormError.email)
    nameError && userFormErrors.push(UserFormError.name)
    phoneError && userFormErrors.push(UserFormError.phone)
    !eulaAccepted && userFormErrors.push(UserFormError.eula)
    !offerAccepted && userFormErrors.push(UserFormError.offer)
    !personalDataAccepted && userFormErrors.push(UserFormError.personalData)
    !informedAgreement && userFormErrors.push(UserFormError.informedAgreement)

    return userFormErrors
}
